import { styled } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const RouteLoadingFallback = () => {
  return (
    <LoadingContainer aria-busy={true} role='progressbar'>
      <CircularProgress color='inherit' />
    </LoadingContainer>
  );
};

const LoadingContainer = styled('div')`
  display: flex;
  height: 100%;
  min-height: 400px;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.palette.colors.primary[500]};
`;

export default RouteLoadingFallback;
